import {createSlice, isAnyOf} from '@reduxjs/toolkit';

import {
    deleteRateThreshold,
    getRateThresholds,
    updateRateThreshold,
} from './spothero-iq-actions';
import {rateThresholdsAdapter} from './spothero-iq-adapters';

/**
 * The initial state of the spotheroIQ slice
 * @property {TRateThreshold[]} rateThresholds - The rate thresholds for the facility
 * @property {boolean} rateThresholds.areRateThresholdsApplicable - Whether or not rate thresholds are applicable to the facility
 * @property {boolean} rateThresholds.isLoading - Whether or not the rate thresholds are loading
 * @property {string} rateThresholds.error - The error message if there was an error loading the rate thresholds
 * @property {boolean} hasIQFacility - Whether or not the facility has an IQ facility
 */
const initialState = {
    rateThresholds: rateThresholdsAdapter.getInitialState({
        areRateThresholdsApplicable: false,
        isLoading: false,
        error: null,
    }),
    hasIQFacility: false,
};

const spotheroIQSlice = createSlice({
    name: 'spotheroIQ',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getRateThresholds.fulfilled, (state, action) => {
                rateThresholdsAdapter.setAll(
                    state.rateThresholds,
                    action.payload.rateThresholds
                );

                state.rateThresholds.areRateThresholdsApplicable =
                    action.payload.areRateThresholdsApplicable;
                state.rateThresholds.isLoading = false;
                state.rateThresholds.error = null;
            })
            .addCase(getRateThresholds.pending, (state) => {
                state.rateThresholds.isLoading = true;
            })
            .addCase(getRateThresholds.rejected, (state, action) => {
                state.rateThresholds.isLoading = false;
                state.rateThresholds.error = action.payload;
            })
            .addMatcher(
                isAnyOf(
                    updateRateThreshold.fulfilled,
                    deleteRateThreshold.fulfilled
                ),
                (state, action) => {
                    rateThresholdsAdapter.setAll(state.rateThresholds, action);
                }
            );
    },
});

export default spotheroIQSlice.reducer;
